import * as $ from 'jquery';

export class CountryCardCommon {

    public static correctHeight(component) {
        let comp = $(component);
        let html = comp.find('div:first-child').html();
        let content = $('<div class="col-md-6">').append('<div class="country-component-text">');
        content.find('.country-component-text').append(html);
        comp.find('div:first-child').remove();
        comp.prepend(content);
        // comp.height(comp.find('.country-component-text').height());
    }

    public static init() {
        $('.country-card-component').each((i,c) => CountryCardCommon.correctHeight(c));

    }


}